import { FC, ReactElement, ReactNode } from 'react'

import s from './CustomTooltip.module.scss'

interface CustomTooltipProps {
  title: string
  children: ReactElement | ReactNode | ReactNode[]
  className?: string
}

const CustomTooltip: FC<CustomTooltipProps> = (props) => {
  const { title, children ,className = ''} = props
  return (
    <div className={`${s.TooltipWrapper} ${className}`}>
      <span className={s.TooltipText}>
        {title}
        <div className={s.TooltipTextAngle}></div>
      </span>
      {children}
    </div>
  )
}

export default CustomTooltip
